module.exports = __webpack_public_path__ + "dc326d9fb6aec5722cf380ede5141a5e.png";